import * as React from 'react';
import { PaginationData } from '../../Model/core';
import { getQueryStringValue, setQuerystring } from '../../util';
import { Prev } from 'react-bootstrap/PageItem';

interface Props {
    onPageChange: (newPage: number) => Promise<PaginationData | null>;
    queryKey: string;
    runOnMount?: boolean;
}
interface State {
    currentPage: number;
    pagination?: PaginationData | null;
}

export class Pagination extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = { currentPage: 1 };
    }

    getPageFromQuery() {
        const { queryKey } = this.props;
        const query = parseInt(getQueryStringValue(queryKey), 10);
        const page: number = isNaN(query) ? 1 : query;
        if (isNaN(query)) {
            setQuerystring({ value: '', key: queryKey });
        }
        return page;
    }

    async componentDidMount() {
        const { runOnMount } = this.props;
        const run = typeof runOnMount === 'undefined' ? true : runOnMount;
        if (run) {
            const page = this.getPageFromQuery();
            await this.goToPage(page);
        }
    }

    async goToPage(page: number): Promise<void> {
        const { onPageChange, queryKey } = this.props;
        setQuerystring({ value: page === 1 ? '1' : page, key: queryKey });
        const pagination = await onPageChange(page);
        if (!pagination) {
            this.setState({ pagination: null });
            return;
        }

        if (page > pagination.LastPage || page <= 0) {
            return await this.goToPage(1);
        }

        this.setState({ pagination, currentPage: page });
    }

    goTo = async (e: React.MouseEvent, page: number) => {
        e.preventDefault();
        await this.goToPage(page);
        await this.updateHeader(page);
    };

    updateHeader = async (page: number) => {
    
        let canonicalLink = document.head.querySelector("link[rel='canonical']");
        if(canonicalLink !== null ){
    
            canonicalLink.setAttribute('href', window.location.href);
            
        };
    }

    
    render() {
        const { pagination } = this.state;
        if (!pagination || pagination.Pages.length <= 1) {
            return <div style={{ display: 'none' }}></div>;
        }
        const { currentPage } = this.state;
        const selected = (page: number) => page === currentPage ? 'selected' : '';

        const previous = Math.max(currentPage - 1, 1);
        const next = Math.min(currentPage + 1, pagination.LastPage);
        const { queryKey } = this.props
        // const { protocol, host, pathname } = window.location;
        // console.log(protocol, host,pathname, window.location)
        // const baseUrl = `${protocol}${host}${pathname}`;
        return (
            <ul className="bl-pagination">
                <li>
                    <a rel='prev' href={`?${queryKey}=${previous}`} className={selected(previous)} onClick={(e) => this.goTo(e, previous)}>Föregående</a>
                </li>
                {pagination.Pages.map((page) => (
                    <li key={page} className="bl-pagination-item">
                        <a  href={`?${queryKey}=${page}`} className={selected(page)} onClick={(e) => this.goTo(e, page)}>{page}</a>     
                    </li>
                ))}
                <li><a rel='next' href={`?${queryKey}=${next}`} className={selected(next)} onClick={(e) => this.goTo(e, next)}>Nästa</a></li>
            </ul>
        );
    }
}